import { createAction } from '@reduxjs/toolkit'
import { call, ForkEffect, put, select, takeEvery } from 'redux-saga/effects'

import { resetActiveFlagAction } from './resetActiveFlag'
import { deleteFlagOpening, unlinkGeometryFromFlag } from '../../../api/projects-api'
import { NormalizedFlag } from '../../../models/flags'
import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import { Flag } from '../../lib/toolBoxes/2D'
import {
    removeOpeningLinkFromFlag,
    selectFlagById,
    selectMaterialActiveFlag,
    setTaskNoteEditMode,
    toggleFlagForm,
} from '../../slices/materialFlags'

export const deleteSingleFlagInstanceAction = createAction<{ flag_id: number; opening_link_id: number }>(
    'deleteSingleFlagInstance'
)

export function* handleDeleteSingleFlagInstance({ payload }: ReturnType<typeof deleteSingleFlagInstanceAction>) {
    try {
        const manager: PaperManager | null = yield call(managers.get2DManager)

        if (!manager) return

        const flagTool: Flag = yield call(manager.getTool, Flag.NAME)

        const { flag_id, opening_link_id } = payload

        const activeFlag: NormalizedFlag | null = yield select(selectMaterialActiveFlag)

        const currentFlag: NormalizedFlag | undefined = yield select(selectFlagById, flag_id)

        const openingLink = currentFlag?.opening_links.find((link) => link.id === opening_link_id)
        const isLinkedToMaterial = openingLink?.opening_id !== null

        // Perform all API operations first before updating UI/store
        if (isLinkedToMaterial) {
            yield call(unlinkGeometryFromFlag, opening_link_id)
        }

        yield call(deleteFlagOpening, opening_link_id)

        // Only update visual and store after all API operations succeed
        yield call(flagTool.removeFlagByFlagIdAndLinkId, flag_id, opening_link_id)

        if (activeFlag && activeFlag.id === flag_id) {
            yield put(resetActiveFlagAction({}))
        }

        yield put(removeOpeningLinkFromFlag({ flag_id, opening_link_id }))

        yield put(toggleFlagForm({ toggleForm: false }))
        yield put(setTaskNoteEditMode({ isEditMode: false }))
    } catch (error) {
        console.error('Error deleting single flag instance:', error)
    }
}

export function* watchForDeleteSingleFlagInstance(): Generator<ForkEffect<never>, void, unknown> {
    yield takeEvery(deleteSingleFlagInstanceAction.type, handleDeleteSingleFlagInstance)
}
